import { fetchServiceFeeSim } from '../fetch';
import { useSearchParams } from './useSearchParams';
import type { Address } from '../../generated/api/address';
import type { ChangeMobileSimParameters } from '../../generated/api/changeMobileSimParameters';
import type { SimType } from '../../generated/api/simType';
import type { Subscription } from '../../generated/api/subscription';
import type { AuthenticatedUser } from '../../public/site/authState';

export const useGetServiceFeeSim = () => {
  const { mdmId } = useSearchParams<{ mdmId: string }>();

  return async (simType: SimType, subscription: Subscription, address?: Address, user?: AuthenticatedUser | null) => {
    const payload: ChangeMobileSimParameters = {
      simType,
      iccId: subscription.details?.mobile?.simCardNumber,
      deliveryAddress: {
        ...{ address: address || ({} as Address) },
        recipient: user?.userName || '',
        phoneNumber: user?.mobile || '',
        companyName: user?.companyName || '',
      },
    };

    return fetchServiceFeeSim(subscription.subscriptionDisplayId, payload, mdmId);
  };
};
